import React from 'react';

const AvatarStack = ({ images = [], extraCount }) => {
  // Ensure images is an array
  const imageArray = Array.isArray(images) ? images : [];
  const displayImages = imageArray.slice(0, 3);
  const remaining = imageArray.length > 3 ? imageArray.length - 3 : 0;

  return (
    <div className="flex items-center -space-x-4">
      {displayImages.map((image, index) => (
        <img
          key={index}
          src={image}
          alt={`Avatar ${index + 1}`}
          className="w-10 h-10 rounded-full border-2 border-gray-800 object-cover"
        />
      ))}
      {remaining > 0 && (
        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-700 text-white text-sm font-semibold border-2 border-gray-800">
          +{remaining}
        </div>
      )}
    </div>
  );
};

export default AvatarStack;
